<template>
  <div>
    <el-dialog
      top="10vh"
      width="1120px"
      style="margin-bottom: 10vh"
      center
      :title="`级距批量 ${
        MultipleSelectionDialogObj.data
          ? MultipleSelectionDialogObj.data.length
          : 0
      } 组修改`"
      :visible="MultipleSelectionDialogObj.visible"
      @close="HandleCancel()"
    >
      <el-row style="z-index: 10; float: right">
        <el-button
          style="float: right"
          @click="order = !order"
          plain
          round
          :icon="order ? 'el-icon-sort-down' : 'el-icon-sort'"
          size="mini"
        ></el-button>
        <el-button
          style="float: right; margin-right: 6px"
          @click="gridMode = !gridMode"
          plain
          round
          :icon="gridMode ? 'el-icon-s-grid' : 'el-icon-s-operation'"
          size="mini"
        ></el-button>
      </el-row>

      <el-row>
        <div style="width: 252px; margin: 0 auto">
          <el-select
            filterable
            v-model="groupOption"
            placeholder="级距分组"
            size="small"
          >
            <el-option
              v-for="option in amsBankCardPriorityGroupBySelectOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
          <el-button size="small" type="success" @click="HandleSubmit()"
            >保存</el-button
          >
        </div>
      </el-row>

      <br />

      <el-table
        v-if="
          !gridMode ||
          (MultipleSelectionDialogObj.data &&
            MultipleSelectionDialogObj.data.length === 0)
        "
        :data="dataList"
        stripe
        style="width: 100%"
      >
        <el-table-column prop="bankName" label="银行名称"></el-table-column>
        <el-table-column
          prop="bankCardNumber"
          label="银行卡卡号"
        ></el-table-column>
        <el-table-column prop="name" label="帐户名"></el-table-column>
        <el-table-column prop="username" label="卡主用户名"></el-table-column>
        <el-table-column label="余额">
          <template slot-scope="scope">
            {{
              formatNumberWithCommasAndDecimalSeparator(scope.row.balance, 2)
            }}
          </template>
        </el-table-column>
        <el-table-column label="积分余额">
          <template slot-scope="scope">
            <span v-if="scope.row.switchShareJifen">
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.userJifenBalance,
                  2
                )
              }}
              (共享)
            </span>
            <span v-else>
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  scope.row.jifenBalance,
                  2
                )
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="现组别">
          <template slot-scope="scope">{{
            scope.row.groupName || "-"
          }}</template>
        </el-table-column>
      </el-table>
      <el-card
        v-else
        class="box-card"
        style="
          width: 24%;
          height: 120px;
          display: inline-block;
          vertical-align: top;
          margin-left: 5px;
          margin-bottom: 5px;
        "
        v-for="item in dataList"
        shadow="never"
        :body-style="{ padding: '10px' }"
        :key="item.id"
      >
        <el-tooltip class="item" effect="dark" placement="right">
          <div slot="content">
            余额：{{ formatNumberWithCommasAndDecimalSeparator(item.balance, 2)
            }}<br />
            积分余额：
            <span v-if="item.switchShareJifen">
              {{
                formatNumberWithCommasAndDecimalSeparator(
                  item.userJifenBalance,
                  2
                )
              }}
              (共享)
            </span>
            <span v-else>
              {{
                formatNumberWithCommasAndDecimalSeparator(item.jifenBalance, 2)
              }}
            </span>
          </div>
          <ul
            class="text item"
            style="margin: 0; padding: 0; line-height: 20px"
          >
            <li>银行名称：{{ item.bankName }}</li>
            <li>银行卡卡号：{{ item.bankCardNumber }}</li>
            <li>帐户名：{{ item.name }}</li>
            <li>卡主用户名：{{ item.username }}</li>
            <li>现组别：{{ item.groupName || "-" }}</li>
          </ul>
        </el-tooltip>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-select
          filterable
          v-model="groupOption"
          placeholder="级距分组"
          size="small"
        >
          <el-option
            v-for="option in amsBankCardPriorityGroupBySelectOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
          >
          </el-option>
        </el-select>
        <!-- <el-button size="small" @click="HandleCancel">关闭</el-button> -->
        <el-button size="small" type="success" @click="HandleSubmit()"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import varCommon from "@/utils/varCommon";
import mainCommon from "@/utils/mainCommon";
import {
  listAmsBankCardPriorityGroupBySelect,
  batchUpdateAmsAccGroupCode,
} from "@/api/account";

export default {
  mixins: [mainCommon],
  props: ["MultipleSelectionDialogObj"],
  data() {
    return {
      gridMode: true,
      groupOption: "",
      order: false,
      amsBankCardPriorityGroupBySelectOptions: [],
    };
  },
  watch: {
    MultipleSelectionDialogObj(row) {
      if (row.visible) {
        this.getListAmsBankCardPriorityGroupBySelect();
      }
    },
  },
  computed: {
    dataList() {
      if (this.MultipleSelectionDialogObj.data) {
        if (this.order) {
          // 可做排序
          let cloneObj = this.HandleDeepCopy(
            this.MultipleSelectionDialogObj.data
          );
          return cloneObj.sort((a, b) => a.bankName.localeCompare(b.bankName));
        } else {
          return this.MultipleSelectionDialogObj.data;
        }
      } else {
        return [];
      }
    },
  },
  methods: {
    getListAmsBankCardPriorityGroupBySelect() {
      listAmsBankCardPriorityGroupBySelect().then((res) => {
        this.amsBankCardPriorityGroupBySelectOptions = res.data.map((res) => {
          return {
            label: res.groupName,
            value: res.groupCode,
          };
        });
      });
    },
    HandleSubmit() {
      if (!this.groupOption) {
        this.$notify.error("未选择组别！");
        return;
      }

      /* 统整出目前选取的记录有几笔与即将更动的组别相同
      相减即为会更新的记录笔数
      */
      let countSameGroup = this.MultipleSelectionDialogObj.data.filter(
        (item) => {
          if (item.groupCode === this.groupOption) {
            return true;
          } else {
            return false;
          }
        }
      ).length;

      // if (this.MultipleSelectionDialogObj.data.length - countSameGroup === 0) {
      //   this.$notify.error("这些银行卡已经在相同分组了");
      //   return;
      // }

      let grouoNameChosen = this.amsBankCardPriorityGroupBySelectOptions.find(
        (item) => item.value === this.groupOption
      ).label;

      this.$confirm(
        `${this.MultipleSelectionDialogObj.data.length} 笔银行卡中有 ${
          this.MultipleSelectionDialogObj.data.length - countSameGroup
        } 笔组的差异将更新为「${grouoNameChosen}」组！`,
        varCommon.message.attention,
        {
          confirmButtonText: varCommon.message.confirm,
          cancelButtonText: varCommon.message.cancel,
          type: "warning",
        }
      )
        .then(() => {
          let idList = this.MultipleSelectionDialogObj.data.map((res) => {
            return res.id;
          });
          batchUpdateAmsAccGroupCode({
            idList,
            groupCode: this.groupOption,
          }).then((res) => {
            this.$notify.success(res.message);
            this.HandleCancel();
            this.$emit("HandleGetList");
          });
        })
        .catch(() => {});
    },
    HandleCancel() {
      this.$emit("update:multiple-selection-dialog-obj", { visible: false });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/BankMultipleSelectionDialog.vue